import { Col, Row, Text } from 'ui';

type P = {
  dialInData: {
    href: string;
    id: string;
    number: string;
    passcode: string;
  };
};

const EventDialInDropdownItem = ({ dialInData: { href, id, number, passcode } }: P) => (
  <Row gutter="ms">
    <Col className="event-dial-in-dropdown-item--wrapper">
      <Text size="small" type="title" uppercase weight="medium">
        Phone number
      </Text>
      <a href={href}>{number}</a>
    </Col>
    <Col className="event-dial-in-dropdown-item--wrapper">
      <Text size="small" type="title" uppercase weight="medium">
        Dial-in ID
      </Text>
      <Text>{id}</Text>
    </Col>
    <Col className="event-dial-in-dropdown-item--wrapper">
      <Text size="small" type="title" uppercase weight="medium">
        Dial-in PASSCODE
      </Text>
      <Text>{passcode}</Text>
    </Col>
  </Row>
);

export default EventDialInDropdownItem;
